// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"8f23fc0e","139":"35fbdc2e","325":"9a04c2ed","843":"35fbdc2e"}[chunkId] + ".chunk.css";
};